import './index.scss';
import {
  Button,
  Image,
  Stack,
  Select,
  Text
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import logo_kokoka from '../../assets/images/logo_kokoka.svg'

const SelectLang = () => {
  //assets
  const system_words: any = {};
  system_words['ja'] = require('../../assets/jsons/lang/ja.json');
  system_words['en'] = require('../../assets/jsons/lang/en.json');
  system_words['vn'] = require('../../assets/jsons/lang/vn.json');
  system_words['ch'] = require('../../assets/jsons/lang/ch.json');

  //states
  var language = navigator.language.substring(0, 2);
  const [selectedLang, setSelectedLang] = useState<string>(language === 'ja' ? 'ja'
    : language === 'vi' ? 'vn' : language === 'en' ? 'en' : language === 'zh' ? 'ch' : 'en');

  const setLang = (lng: string) => {
    setSelectedLang(lng);
  };

  const submitToAgree = () => {
    localStorage.setItem('systemLanguage', selectedLang);
    // 翻訳アイコンで表示する言語の設定(日本語選択時は英語)
    localStorage.setItem('translationLanguage', selectedLang == 'ja' ? 'en' : selectedLang == 'vn' ? 'ch' : selectedLang);
    window.location.replace('/agree');
  }

  return (
    <>
      <Stack
        id="bg-image"
        pb="5px"
        m="auto"
        w="375px"
        h="100vh"
        bgSize="cover"
        boxSizing="content-box"
        bgColor="white"
        spacing="24px"
        align="center"
        pt="250px"
      >
        <Image
          src={logo_kokoka}
          w={{ base: "220px", lg: "290px" }}
          h={{ base: "80px", lg: "110px" }}
        />
        <Text fontSize="24px" textAlign="center" px="20px">
          {system_words[selectedLang]['KT_0001_01']}
        </Text>
        <form>
          <Select
            id="select_lang"
            size="md"
            minWidth="300px"
            onChange={event => setLang(event.currentTarget.value)}
            value={selectedLang}
          >
            <option value="ja">日本語</option>
            <option value="en">English</option>
            <option value="vn">Tiếng Việt</option>
            <option value="ch">中文</option>
          </Select>
        </form>
        <Button
          id="single_btn"
          className="btn-border"
          onClick={() => submitToAgree()}
          textColor="white"
          bgColor="orange"
          w="300px"
        >
          {system_words[selectedLang]['KT_0001_02']}
        </Button>
        <Text fontSize="18px" textAlign="center" px="20px">
          {system_words[selectedLang]['KT_0001_03']}
        </Text>
      </Stack>
    </>
  );
};

export default SelectLang;
